import React, { useId, useState } from "react";
import { MdOutlineCategory } from "react-icons/md";
import { useTranslation } from "react-i18next";

interface EditCategoryInputProps {
  EditCategoryInputs: { ar: string; en: string };
  onChange: (newValues: { ar: string; en: string }) => void;
}

function EditCategoryInput({ EditCategoryInputs, onChange }: EditCategoryInputProps) {
  const { t,i18n } = useTranslation();
  const locale = i18n.language
  const initialInputValue = locale === "ar" ? "ar": "en" 
  const [EditCategoryInputLang, setEditCategoryInputLang] = useState<"ar" | "en">(initialInputValue);
  const id = useId();

  const handleEditCategoryInputChange =
    (lang: "ar" | "en") => (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      onChange({ ...EditCategoryInputs, [lang]: value });
    };

  const handleEditCategoryInputLangChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setEditCategoryInputLang(e.target.value as "ar" | "en");
  };

  return (
    <div className="relative flex h-10 w-full items-start justify-start overflow-hidden rounded-md border border-gray-300">
      <MdOutlineCategory size={20} className="absolute start-2 top-1/2 -translate-y-1/2 text-gray-400" />

      {EditCategoryInputLang === "ar" && (
        <input
          name={`${id}-EditCategoryInputAr`}
          id={`${id}-EditCategoryInputAr`}
          className="h-full w-full rounded-md ps-10 pe-[55px]"
          type="text"
          placeholder={t("editCategoryInput.nameAr")}
          value={EditCategoryInputs.ar}
          onChange={handleEditCategoryInputChange("ar")}
        />
      )}

      {EditCategoryInputLang === "en" && (
        <input
          name={`${id}-EditCategoryInputEn`}
          id={`${id}-EditCategoryInputEn`}
          className="h-full w-full rounded-md ps-10 pe-[55px]"
          type="text"
          placeholder={t("editCategoryInput.nameEn")}
          value={EditCategoryInputs.en}
          onChange={handleEditCategoryInputChange("en")}
        />
      )}

      <select
        className="absolute end-0 top-0 h-full w-[3rem] rounded-md"
        name="EditCategoryInput-lang"
        value={EditCategoryInputLang}
        onChange={handleEditCategoryInputLangChange}
      >
        <option value="ar">AR</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}

export default EditCategoryInput;
